import { Navigate } from "react-router-dom";
import { useDataContext } from "../context/data";

const ProtectedRoute = ({ allowedRoles, element }) => {

  const { user } = useDataContext();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.user_type)) {

    return <Navigate to="/unauthorized" replace />;

  }

  return element
};

export default ProtectedRoute;
